module.exports = __webpack_public_path__ + "img/left_video2.d83cc103.png";